<template>
  <div class="bg-container page">
    <img class="bg-img" v-if="this.$store.getters.getBaseInfo.login_bg !==undefined" :src="this.$store.getters.getBaseInfo.login_bg !==undefined ?this.$store.getters.getBaseInfo.login_bg:''">

    <div class="bg-wrapper">
        <div class="login">
          <van-nav-bar class="nav-bar">
            <template #left>
              <img @click="$router.push('/')" src="img/home.png" style="width: 30px; ">
            </template>
            <template #right>
              <img @click="service" style="width: 30px; " src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABXJJREFUaEPVmb2yDUEUhZdcFV7AzxMgUSVCgBClxHgCPIBCkeMF/IQkSAkQCxCQ4gnwAIr6bs06tc8+09M9c2YCXXXr3nvOme691l577e4+u/Sfj10LxH9E0p5u3pOSvnc/vPR+7vXmALBX0jlJBHteEv8PjXeSXkp6FYBNxrUNAAK9Jul6Q9ClAJ9Ieijp01QEUwFckXR/IPDPkn6loE4MBPlA0p2eZ6q4xgKA9cedVOLkvyXBpuVRWpj6QGoQcDh9iFq5MDYbYwAQ/FtJBOFB4LDHT2a8xh5AbkuKmWEOQEBE02gF0Bc8RQiTfYEflHQgAS3pnBpCjnFc7TJaBdEK4GNi/kbHuhcA4OVOHjBbciJAwC6Fi2Q8yCqv234h5VSLnFoAIA/cxiOyQ6Cwl+2zr4hjf2AuAqZwLZcMArCAGJRmDQBsonsPFkS3DEDxt9l+2vk7Hl8aBAlYpGeJUfxklEAzCDKFxIqjBuCbJPTMoIsCiIETEQSDwFlkbBHzDAQgG9gms/zONXFoqOENAcjseyLXAw4Em82O0UMj2SNjOFHUPXPanSDIZG1MMQQA6ZhxT2Lm0TjBx0IcynTtPWSECQACopBSlG4xCyUAyAb5eDABLNySBPO8P1YyGQRBModJMAhkdLTLrLOQXW81VwkAwcK2tY8ukQ6DySfvXbqsMjckIBWcxoN56dAuasdgUM0SQpfsMBlMhpT4P7pQTRal93+mPhHZJSsQ5XowaczlrQpyLmaACfB1a58P0tpfzCQdGwOO5qwSLFnNUoKsaLcOGnKJaWdECZFSEOMM6JyBxbEAr83Bvi3Sc7lJRqdx/XldYrELYbtIbNVMI4A8GROhPbf3QT9u0BMkQBDzuo54DeZZI84fbTQSh/OhhhXgCMAPUVT2dhDbeWonrSEMSJOC5HdsiDzjNWIWbCLZ8aIEd2ReA+B0svMEfcsgSNLMsyzC/wZP/+C1aMExC/uCZMkMqvDWhbVHA3D1IyUmy8PB8tuHlT6QBI6L9M3hNWhk0ZEcfAQ7CQBMwlL0frKBW3mfFINGIrDH5719rmVuI7Au43ljOAuA2OR+dHsZB7tNg/ubnJHgkU+ccxIAUm8JudGwVrG91+guvG8TsUPR8Hzq8yOjAeQidoeeoydkHLZxmhQSdBeO9joagC2OQsIhSPNcm7kMwGtBDgP7ZkSyLN+VK0Yb9QRIhk4XOzMT8Rpenn18omI2HosA2HfF2w+yYxljKL2dOHderwDjdEoaDVa3NACvg0EAyjtSx7N2wMnbaVDzEAz4sgr0nA3QpW2zdhSdkhVnwM/aJFiT2qM5btReayA+bHhyCm3o8L4tgFxn3oJvnEVaAeQT2uA5tRL9bkn7JX1Nn4sbuGjRdh4ktdE4WwGwVmxgPruOPVaelnRX0k1JbxIAs5xrzGfzXuseAyDuWbK9ORZ0TJBfOtcwy8ck8XOxC/5eCj7uPqlDH27izYg3emuPjgWAhVEPPm72nY8vSXpekNEHSccl/Qnv+5xAgATsrUO8jy1ecI0F4HXjDULf9d/ZLtAz3e9nkh5Jet0DjAOKbz3ivide4eQt+GqaqQCYgB0pQAiAxjJlECSOg/RiPcWbv8FbkG0AEDBp5pwLc1NsFb1H1n1Z7DNw9Zp9WwBTWC89g0x8X0RWYj0U11kKgL8AZGEcZe0uJ0VDoGzcfJXD6Y0MNJ0tlgCQN4G231gn8WtZNyd/XRXPwNUMLwHADgXrdFf2UmwG+Tse8B0cHdbn5bGNce1Wooq28QP5ZJW/4WEaZOJvNLe5nl8EQOwRBOdvWPwV6lxX8jt8LiEhCpjA4/fAVTtszO7Gx5YA4EV8qUV/mJX1iGJJAFNJHfXcP/mqiEDZsEJxAAAAAElFTkSuQmCC">
            </template>
          </van-nav-bar>
          <div class="wrapper">
            <div class="logo-container">
              <div class="logo-wrapper">
                <img class="logo-img" :src="this.$store.getters.getBaseInfo.login_ico !==undefined ?this.$store.getters.getBaseInfo.login_ico:'/img/null.png'">
              </div>
            </div>
            <div class="loginForm">
              <div class="title" v-if="false">{{ $t("login.title") }}</div>
              <van-field v-model="username"  clearable  class="input"  :placeholder="$t('login.username')" />
              <van-field
                  v-model="password"
                  :type="passwordType"
                  class="input"
                  :placeholder="$t('login.password')">
                <template slot="right-icon">
                  <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
                </template>
              </van-field>
              <van-button class="login-btn"   type="primary" size="normal" @click="doLogin()">{{ $t("login.doLogin") }}</van-button>
              <div class="reset-text">
                <span>{{ $t("login.registerNow") }}</span>
                <span @click="toRegister()" style="color:#f24255">
                  {{ $t("注册帐户") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      username: '',
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  methods: {

    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },

    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back(){
      return window.history.back();
    },
    toRegister(){
      this.$router.push("Register")
    },
    doLogin() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast(this.$t('login.username')+"!");
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast(this.$t('login.password')+"!");
        return false;
      }
      this.$http({
        method: 'get',
        data:{username:this.username,password:this.password},
        url: 'member_login'
      }).then(res=>{
        console.log(res);
          if(res.code === 200){
            console.log(res.data.id);
            this.$toast.success(this.$t("msg."+res.msg));
            localStorage.setItem('token',res.data.id)
            localStorage.setItem('tokencc',res.data.token)
            this.$router.push("Home")
          }else {
            this.$toast(this.$t("msg."+res.msg));
          }
      })
    }
  },
  created() {
      if(localStorage.getItem('token')){
        this.$router.push("Home")
      }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.login{
  height: 100%;
}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container{
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper .logo-img{
  width: 100%;
  margin: 2rem 0 1rem 0;
}
.login .wrapper .title{
  font-size: 45px;
  font-weight: 700;
  color: #000;
  margin-top: 10px;
  line-height: 60px;
}
.login .wrapper .title1{
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
  color: #848fac;
  margin-top: 10px;
}
.label{
  color: #2a3563;
  line-height: 50px;
  font-size: 40px;
  font-weight: 600;
}
.login .wrapper .loginForm .input{
  padding: 10px 20px;
  margin-top: 40px;
  border: 1px solid #dfe8f6;
  line-height: 70px;
  font-size: 30px;
  color: #4e4e4e;
  border-radius: 20px;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 40px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.login .wrapper .loginForm .reset-text{
  margin: 30px 15px;
  text-align: center;
  font-size: 28px;
}
.login .wrapper .loginForm .reset-text span{
  color: #333;
  font-weight: 500;
}
.login .wrapper .loginForm .register-text{
  margin: 30px 0;
  text-align: right;
}
.login .wrapper .loginForm .register-text span{
  font-size: 32px;
  font-weight: 600;
}
.login .wrapper .loginForm .login-btn{
  margin-top: 50px;
  width: 100%;
  height: 100px;
  border-radius: 15px;
  color: #fff;
  background: linear-gradient(90deg, #e62978, #cc2996);;
  font-size: 34px;
  font-weight: bolder;
  border: none;
}

</style>
